import type { TNumberRange } from './number.types.ts';

const decimalFormat = /^-?\d+(\.\d+)?$/;
const positiveIntegerFormat = /^[1-9]\d*$/;

export const isValidDecimal = (
  text: string,
  { min, max }: TNumberRange = {},
): boolean => {
  if (!decimalFormat.test(text)) {
    return false;
  }

  const value = Number(text);

  return (
    (min === undefined || value >= min) && (max === undefined || value <= max)
  );
};

export const parsePositiveInteger = (
  text?: string | null,
): number | undefined => {
  if (!text || !positiveIntegerFormat.test(text)) {
    return undefined;
  }

  const value = Number(text);

  return Number.isSafeInteger(value) ? value : undefined;
};
